interface ProfileArticleHeader {
  image: string
  publishDate: string
}

function ProfileArticleHeader({ image, publishDate }: ProfileArticleHeader) {
  return (
    <div
      className='h-[191px] self-stretch bg-cover bg-center bg-no-repeat relative rounded-t-[10px]'
      style={{
        backgroundImage: `url(${image}), linear-gradient(to bottom, #E5F9FE, #E5F9FE)`,
      }}
    >
      <div className='flex px-2 py-1 justify-center items-center gap-[10px] absolute left-4 top-4 rounded-[10px] bg-white'>
        <p className='text-center text-sm font-medium  text-[#122D5C] px-2'>
          {publishDate}
        </p>
      </div>
    </div>
  )
}

export default ProfileArticleHeader
